<template>
  <div>
    <b-row>
      <b-col
        cols="12"
      >
        <!-- Table Container Card -->
        <b-card
          no-body
          class="mb-0"
        >
          <div class="m-2">
            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col
                class="mt-1 mt-lg-0 d-flex align-items-center justify-content-start"
                cols="12"
                md="12"
                lg="12"
              >
                <div class="d-flex align-items-center justify-content-end w-100">
                  <b-button class="ml-1" variant="primary" @click="openImportModal">
                    <span class="text-nowrap">
                      Nova Importação
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>

          <b-table
            ref="refUserListTable"
            class="position-relative table-physician"
            :items="fetchPhysicians"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro correspondente encontrado"
            :sort-desc.sync="isSortDirDesc"
          >
            <template #cell(status)="{ item, index }">
              <div class="d-flex align-content-start">
                <b-tooltip
                  title="Importado com sucesso"
                  :target="`status-processed-${index}`"
                />
                <b-badge
                  v-if="item.status === 'processed' && item.metrics.errors == 0"
                  :id="`status-processed-${index}`"
                  pill
                  variant="light-success"
                >
                  Importado
                </b-badge>
                <div v-else class="d-flex flex-column align-items-center justify-content-center">
                  <div>
                    <b-tooltip
                      title="Em processamento aguarde"
                      :target="`status-processing-${index}`"
                    />
                    <b-badge
                      v-if="item.status === 'processing'"
                      :id="`status-processing-${index}`"
                      class="progress-bar"
                      pill
                      variant="light-secondary"
                    >
                      Processando
                    </b-badge>
                  </div>
                  <div>
                    <b-tooltip
                      title="Importado parcialmente com falha"
                      :target="`status-errors-${index}`"
                    />
                    <b-badge
                      v-if="item.status === 'processed'"
                      :id="`status-errors-${index}`"
                      pill
                      variant="light-danger"
                    >
                      Com Falha
                    </b-badge>
                  </div>
                  <div v-if="item.metrics" class="d-inline-block text-muted font-weight-bold">
                    <span>{{ item.metrics.imports }}</span>/<span class="font-weight-bold">{{ item.metrics.errors + item.metrics.imports }}</span> importados
                  </div>
                </div>
              </div>
            </template>
            <template #cell(actions)="data">
              <b-dropdown
                variant="link"
                no-caret
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  :to="{
                    name: 'import-physician-duty-view',
                    params: { id: data.item.id },
                  }"
                >
                  <feather-icon icon="FileTextIcon" />
                  <span class="align-middle ml-50">Detalhes</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-start
                "
              >
                <span class="text-muted">
                  Exibindo {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-end
                "
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalUsers"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      id="modal-import"
      ref="importModal"
      size="lg"
      title="Importação de Plantões"
      hide-footer
      no-close-on-backdrop
    >
      <template #modal-header="{ close }">
        <div class="d-flex align-items-center">
          <b-avatar variant="light-dark" rounded="sm">
            <feather-icon icon="FileTextIcon" size="18" />
          </b-avatar>
          <div class="ml-1">
            <h5 class="modal-title">
              Importação de Plantões
            </h5>
            <small class="text-muted">Importe sua escala de propfissioneis via CSV</small>
          </div>
        </div>
        <button type="button" aria-label="Close" class="close" @click="close">
          ×
        </button>
      </template>

      <div>
        <div class="d-flex align-items-center mb-1">
          <b-avatar
            text="1"
            size="sm"
            variant="light-primary"
          />
          <h6 class="m-0 ml-1">
            Prepare seu arquivo
          </h6>
        </div>
        <b-card
          bg-variant="light-primary"
          align="center"
          class="position-static mb-1"
        >
          <div class="d-flex align-items-center">
            <div class="text-left">
              <h6 class="mb-0">
                Baixe o modelo de planilha
              </h6>
              <small class="text-muted">Use como base para preencher seus dados corretamente</small>
            </div>
            <div class="flex-grow-1 d-flex align-items-end justify-content-end">
              <b-button
                variant="secondary"
                size="sm"
                class="text-nowrap"
                @click="downloadModel"
              >
                <feather-icon
                  icon="DownloadIcon"
                  class="mr-50"
                />
                <span class="align-middle">Modelo PF</span>
              </b-button>
              <b-button
                variant="secondary"
                size="sm"
                class="text-nowrap ml-1"
                @click="downloadModelCnpj"
              >
                <feather-icon
                  icon="DownloadIcon"
                  class="mr-50"
                />
                <span class="align-middle">Modelo PJ</span>
              </b-button>
            </div>
          </div>
        </b-card>

        <app-collapse type="border">
          <app-collapse-item title="Ver campos aceitos no arquivo" :is-visible="false">
            <div class="flex-column accepted-list">
              <div class="bg-light-secondary rounded">
                <b-badge variant="light-primary">
                  nome
                </b-badge>
                Joao da Silva
              </div>
              <div>
                <b-badge variant="light-primary">
                  cpf
                </b-badge>
                123.456.789-10, 12345678910
              </div>
              <div>
                <b-badge variant="light-primary">
                  numero_conselho
                </b-badge>
                12345
              </div>
              <div>
                <b-badge variant="light-primary">
                  uf
                </b-badge>
                SP, sp
              </div>
              <div>
                <b-badge variant="light-primary">
                  data_hora_inicio
                </b-badge>
                12/01/26 10:00, 12/01/2026 10:00:00
              </div>
              <div>
                <b-badge variant="light-primary">
                  data_hora_fim
                </b-badge>
                12/01/26 10:00, 12/01/2026 10:00:00
              </div>
              <div>
                <b-badge variant="light-primary">
                  tipo_plantao
                </b-badge>
                Geral, Pediatra, Pediatria
              </div>
              <div>
                <b-badge variant="light-primary">
                  valor
                </b-badge>
                R$ 10,50, 10.50
              </div>
              <div>
                <b-badge variant="light-primary">
                  cnpj
                </b-badge>
                03.224.282/0001-07, 03224282000107 <small class="text-body-secondary text-danger">*Obrigatório no modelo PJ</small>
              </div>
              <div>
                <b-badge variant="light-primary">
                  empresa
                </b-badge>
                Empresa LTDA <small class="text-body-secondary text-danger">*Obrigatório no modelo PJ</small>
              </div>
              <div>
                <b-badge variant="light-primary">
                  complemento
                </b-badge>
                Geral Noturno, Geral Dia
              </div>
            </div>
          </app-collapse-item>
        </app-collapse>

        <div class="d-flex align-items-center mb-1 mt-2">
          <b-avatar
            text="2"
            size="sm"
            variant="light-primary"
          />
          <h6 class="m-0 ml-1">
            Envie o arquivo preenchido
          </h6>
        </div>
        <div class="mt-1">
          <div
            @dragover.prevent="isDragging = true"
            @dragleave="isDragging = false"
            @drop.prevent="handleDrop"
          >
            <b-card
              class="text-center p-0 transition-bg"
              :style="isDragging ? 'background-color: rgba(87, 87, 86, 0.19) !important; border-color: #6f42c1;' : 'background-color: rgba(87, 87, 86, 0.12) !important; border: 2px dashed #b7b6ba;'"
            >
              <div class="d-flex flex-column align-items-center">
                <feather-icon
                  icon="UploadCloudIcon"
                  size="40"
                  class="mb-1"
                />

                <div class="d-flex align-items-center mb-1">
                  <h5 style="color: #4a3a6b;" class="m-0">
                    Arraste seu arquivo aqui
                  </h5>
                  <p class="text-muted small m-0" style="margin-left: 4px!important;">
                    ou clique para selecionar
                  </p>
                </div>
                <input
                  ref="fileInput"
                  type="file"
                  class="d-none"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="handleFiles"
                >
                <b-button variant="outline-primary" size="sm" @click="$refs.fileInput.click()">
                  Selecionar do Computador
                </b-button>
                <div v-if="file" class="mt-2 d-flex align-items-center text-success font-weight-bold">
                  <feather-icon
                    icon="CheckCircleIcon"
                    size="18"
                  />
                  <div style="margin-left: 4px">
                    {{ file.name }}
                  </div>
                </div>
                <h5 v-if="fileError" class="mt-2 d-flex align-items-center text-danger font-weight-bold">
                  <div>{{ fileError }}</div>
                </h5>
              </div>
            </b-card>
          </div>
        </div>
      </div>

      <!-- select workplace-->
      <div class="d-flex align-items-center mb-1 mt-2">
        <b-avatar
          text="3"
          size="sm"
          variant="light-primary"
        />
        <h6 class="m-0 ml-1">
          Selecione a unidade de destino
        </h6>
      </div>
      <div class="d-flex w-100">
        <div class="flex-grow-1">
          <v-select
            id="workplace-id"
            v-model="workplaceId"
            name="workplace-id"
            :options="workplaceOptions"
            label="label"
            item-value="value"
            item-text="label"
          >
            <span slot="no-options">Nenhum local encontrado.</span>
          </v-select>
        </div>
      </div>

      <!-- select profession-->
      <div class="d-flex align-items-center mb-1 mt-2">
        <b-avatar
          text="4"
          size="sm"
          variant="light-primary"
        />
        <h6 class="m-0 ml-1">
          Selecione uma profissão
        </h6>
      </div>
      <div class="d-flex w-100">
        <div class="flex-grow-1">
          <v-select
            id="workplace-id"
            v-model="professionId"
            name="workplace-id"
            :options="professionOptions"
            label="label"
            item-value="value"
            item-text="label"
          >
            <span slot="no-options">Nenhum local encontrado.</span>
          </v-select>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <div class="mt-2">
          <b-button :disabled="loading || !isValid" class="ml-1" variant="primary" @click="sendFile">
            <span class="text-nowrap">
              Importar Plantões
            </span>
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BAvatar,
  BRow,
  BCol,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BButton,
  BModal,
  VBModal,
  BBadge,
  BTooltip,
} from 'bootstrap-vue'
import store from '@/store'
import {
  computed, onUnmounted, ref, watch,
} from '@vue/composition-api'
import { downloadFile } from '@core/utils/utils'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import vSelect from 'vue-select'
import { tr } from 'date-fns/locale'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import usePhysicianDutyList from './usePhysicianDutyList'
import physicianStoreModule from '../physicianDutyStoreModule'

export default {
  components: {
    BTooltip,
    BAvatar,
    vSelect,
    BBadge,
    BCard,
    BRow,
    BCol,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BButton,
    BModal,
    AppCollapse,
    AppCollapseItem,
  },
  directives: {
    'b-modal': VBModal,
  },
  computed: {
    tr() {
      return tr
    },
  },
  setup() {
    const MODULE_NAME = 'app-physician'
    const toast = useToast()

    // Register module
    if (!store.hasModule(MODULE_NAME)) { store.registerModule(MODULE_NAME, physicianStoreModule) }

    const importModal = ref(null)
    const file = ref(undefined)
    const loading = ref(false)
    const workplaceId = ref(null)
    const professionId = ref(null)
    const workplaceOptions = ref([])
    const professionOptions = ref([])
    const isDragging = ref(false)
    const fileError = ref(null)

    const isValid = computed(() => file.value && workplaceId.value && professionId.value)

    store.dispatch(`${MODULE_NAME}/fetchWorkplaces`, {})
      .then(response => {
        workplaceOptions.value = response.data.data.map(work => ({
          value: work.id,
          label: `${work.name}`,
        }))
      })

    store.dispatch(`${MODULE_NAME}/fetchProfessions`, {})
      .then(response => {
        professionOptions.value = response.data.data.map(p => ({
          value: p.id,
          label: `${p.label}`,
        }))
        if (professionOptions.value.length === 1) {
          // eslint-disable-next-line prefer-destructuring
          professionId.value = professionOptions.value[0]
        }
      })

    const openImportModal = () => {
      importModal.value.show()
    }

    watch(file, () => {
      // validateFile(file.value)
    }, { deep: true })

    const downloadModel = () => {
      downloadFile('importacao-plantoes-pf.csv', `"nome";"cpf";"numero_conselho";"uf";"data_hora_inicio";"data_hora_fim";"tipo_plantao";"complemento";"valor"
"Joao Silva";"487.717.360-93";;;"12/01/26 10:00";"12/01/26 14:00";"GERAL";;"R$ 400.00"
"José Oliveira Santos";"08235194054";"275787";"BA";"12/01/26 14:00";"12/01/26 14:30";"Pediatra";;1500
`)
    }

    const downloadModelCnpj = () => {
      downloadFile('importacao-plantoes-pj.csv', `"nome";"cpf";"numero_conselho";"uf";"data_hora_inicio";"data_hora_fim";"tipo_plantao";"complemento";"valor";"cnpj";"empresa"
"Joao Silva";"487.717.360-93";;;"12/01/26 10:00";"12/01/26 14:00";"GERAL";;"R$ 400.00";"00.394.460/0058-87";"Empresa Teste LTDA"
"José Oliveira Santos";8235194054;275787;"BA";"12/01/26 14:00";"12/01/26 14:30";"Pediatra";;1500;"00394460005887";"Empresa Teste LTDA"
`)
    }

    const {
      fetchPhysicians,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      uploadFile,
      onUnmountedList,
    } = usePhysicianDutyList()

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) { store.unregisterModule(MODULE_NAME) }
      onUnmountedList()
    })

    const sendFile = () => {
      loading.value = true
      const data = {
        workplaceId: workplaceId.value.value,
        professionId: professionId.value.value,
      }
      return uploadFile(file.value, data)
        .then(() => {
          importModal.value.hide()
          file.value = undefined
          workplaceId.value = null
          refetchData()
          loading.value = false
        })
        .catch(error => {
          loading.value = false

          let title = 'Erro ao enviar arquivo'
          const { message } = error.response.data
          if (['file already uploaded', 'Arquivo já enviado'].includes(message)) {
            title = message
          } else if (message === 'required columns not present') {
            title = 'Colunas faltantes'
          } else if (message && !/App\\/.test(message)) {
            title = message
          }
          toast({
            component: ToastificationContent,
            props: {
              title,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    function validarCSV(fileCandidate) {
      // 1. Validação por Extensão (Mais confiável para CSV)
      const fileName = fileCandidate.name.toLowerCase()
      const isExtensionValid = fileName.endsWith('.csv')

      // 2. Validação por MIME Type (Opcional, mas boa prática)
      // CSVs podem variar muito de MIME type dependendo do SO (excel, text/plain, etc)
      const validTypes = [
        'text/csv',
        'application/vnd.ms-excel',
        'application/csv',
        'text/x-csv',
        'text/plain', // Alguns sistemas enviam CSV como plain text
      ]
      // eslint-disable-next-line no-unused-vars
      const isMimeValid = validTypes.includes(fileCandidate.type) || !fileCandidate.type

      if (isExtensionValid && isMimeValid) {
        file.value = fileCandidate
        fileError.value = null
        return true
      }
      file.value = null
      fileError.value = 'Arquivo inválido! Por favor envie apenas .CSV'
      return false
    }

    function handleDrop(e) {
      this.isDragging = false
      const droppedFiles = e.dataTransfer.files
      if (droppedFiles.length && validarCSV(droppedFiles[0])) {
        // eslint-disable-next-line prefer-destructuring
        file.value = droppedFiles[0]
      }
    }
    function handleFiles(e) {
      const selectedFiles = e.target.files
      if (selectedFiles.length && validarCSV(selectedFiles[0])) {
        // eslint-disable-next-line prefer-destructuring
        // file.value = selectedFiles[0]
      }
    }

    return {
      professionId,
      professionOptions,
      fileError,
      handleDrop,
      handleFiles,
      downloadModel,
      downloadModelCnpj,
      fetchPhysicians,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      // UI
      openImportModal,
      importModal,
      file,
      isDragging,
      sendFile,
      loading,
      isValid,
      workplaceId,
      workplaceOptions,
    }
  },
}
</script>

<style lang="scss">
.b-avatar-text {
  font-size: 11px!important;
}
</style>

<style lang="scss" scoped>
.accepted-list > div {
  padding: 6px;
  background: rgba(130, 134, 139, 0.06) !important;
  margin-bottom: 5px;
}

.per-page-selector {
  width: 90px;
}
.table-physician {
  min-height: 200px;
}

.progress-bar{
  max-width: 100px;
  background: rgb(178, 175, 165);
  -webkit-animation-name: pulse; /* Chrome, Safari, Opera */
  -webkit-animation-duration: 2s; /* Chrome, Safari, Opera */
  -webkit-animation-iteration-count: infinite;
  animation-name: pulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@-webkit-keyframes pulse {
  0%   {background: rgb(205, 205, 204);}
  25%   {background: rgb(205, 205, 204);}
  50%   {background: rgb(205, 205, 204);}
  75%  {background: rgb(233, 233, 232);}
  85%{background: rgb(205, 205, 204);}
  100% {background: rgb(205, 205, 204);}
}

@keyframes pulse {
  0%   {background: rgb(205, 205, 204);}
  25%   {background: rgb(205, 205, 204);}
  50%   {background: rgb(205, 205, 204);}
  75%  {background: rgb(233, 233, 232);}
  85%{background: rgb(205, 205, 204);}
  100% {background: rgb(205, 205, 204);}
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
